import { cva } from 'class-variance-authority';

export type RadioSize = 'standard' | 'sm';

/**
 * Outer ring shared by the interactive Radio and the presentational RadioIndicator.
 * State comes from the `data-state` / `data-disabled` attributes; each consumer owns its
 * own disabled and error ring colours.
 */
export const radioVariants = cva(
  'aspect-square shrink-0 rounded-full border-1 border-border-field [&[data-state=checked]:not([data-disabled])]:border-border-active',
  {
    variants: {
      size: {
        standard: 'size-6',
        sm: 'size-4',
      },
    },
    defaultVariants: {
      size: 'standard',
    },
  },
);

export const radioDotVariants = cva('rounded-full', {
  variants: {
    size: {
      standard: 'size-4',
      sm: 'size-2',
    },
    disabled: {
      true: 'bg-action-primary-disabled',
      false: 'bg-action-primary',
    },
  },
  defaultVariants: {
    size: 'standard',
    disabled: false,
  },
});
